import React, { useEffect, useState } from 'react';

import JobBoard from '../../components/jobs/job-board/job-board.component';
import Sidebar from '../../components/sidebar/sidebar.component';
import Users from '../../components/users/users.component';
import './main-page.styles.scss';

export interface SidebarProps {
  currPage: string;
  setCurrPage: React.Dispatch<React.SetStateAction<string>>;
  isOpen: boolean;
  toggleSidebar: () => void;
}

export interface JobBoardProps {
  openSidebar: boolean;
}

interface MainProps {
  openSidebar: boolean;
  toggleSidebar: () => void;
}

const Main: React.FC<MainProps> = ({ openSidebar, toggleSidebar }) => {
  const [currPage, setCurrPage] = useState<string>('dashboard');

  // Function to toggle the sidebar
  useEffect(() => {
    console.log('Main Page re-rendered. openSidebar:', openSidebar);
  }, [openSidebar]);

  const renderPage = () => {
    switch (currPage) {
      case 'dashboard':
        return <JobBoard openSidebar={openSidebar} />;
      case 'users':
        return (
          <Users openSidebar={openSidebar} toggleSidebar={toggleSidebar} />
        );
      default:
        return <JobBoard openSidebar={openSidebar} />;
    }
  };

  const sidebarProps: SidebarProps = {
    currPage,
    setCurrPage,
    isOpen: openSidebar,
    toggleSidebar,
  };

  return (
    <main className="main">
      <Sidebar {...sidebarProps} />
      {renderPage()}
    </main>
  );
};

export default Main;
